import { Model } from 'infra/model'
import { TxfJobDTO } from './dtos/txf-job'
import { makeObservable, observable } from 'mobx'
import { Id } from 'types/definitions'
import { maybeParseDate } from 'utils/date-util'

export default class TxfJob extends Model<TxfJobDTO, TxfJob> {
  jobId: Id = ''
  createdAt?: Date = undefined
  modifiedAt?: Date = undefined

  constructor() {
    super()

    makeObservable(this, {
      jobId: observable,
      createdAt: observable,
      modifiedAt: observable,
    })
  }

  parse(attrs: Partial<TxfJobDTO>): Partial<TxfJob> {
    return {
      jobId: attrs.job_id,
      createdAt: maybeParseDate(attrs.create_time),
      modifiedAt: maybeParseDate(attrs.update_time),
    }
  }
}
